// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { HttpClientInstance } from "@toggl/sync/http";
import {
  CareersOpeningOverview,
  JobopeningCareersAvailable,
  JobopeningGenerateOutput,
  JobopeningOpeningDescription,
  JobopeningPatchOpeningDescription,
  PublicJobOpening,
} from "../types";

export async function getPublicJobopening(
  httpClient: HttpClientInstance,
  slug: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`jobopenings/${slug}`, { signal })
    .json<PublicJobOpening>();
  return response;
}

export async function getJobopeningCareers(
  httpClient: HttpClientInstance,
  workspaceId: number,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`workspaces/${workspaceId}/careers/openings`, { signal })
    .json<CareersOpeningOverview[]>();
  return response;
}

export async function getJobopeningCareersAvailable(
  httpClient: HttpClientInstance,
  workspaceId: number,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`workspaces/${workspaceId}/careers/openings/available`, { signal })
    .json<JobopeningCareersAvailable[]>();
  return response;
}

export async function getJobopeningDescription(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`workspaces/${workspaceId}/openings/${openingId}`, { signal })
    .json<JobopeningOpeningDescription>();
  return response;
}

export async function patchJobopeningDescription(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  data: Partial<JobopeningPatchOpeningDescription>,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .patch(`workspaces/${workspaceId}/openings/${openingId}`, {
      signal,
      json: data,
    })
    .json<JobopeningOpeningDescription>();
  return response;
}

export async function generateJobDescription(
  httpClient: HttpClientInstance,
  workspaceId: number,
  openingId: number,
  data: "solo" | "1-5" | "5-10" | "11-20" | "20+",
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`workspaces/${workspaceId}/openings/${openingId}/description`, {
      signal,
      json: data,
    })
    .json<JobopeningGenerateOutput>();
  return response;
}
